export function getBrowserLang() {
  const languages = [navigator.language, ...(navigator.languages || [])].filter(
    Boolean
  );
  const isJapanese = languages.some((lang) =>
    String(lang).toLowerCase().startsWith("ja")
  );
  return isJapanese ? "jp" : "ch";
}

export function resolveLang() {
  const savedLang = localStorage.getItem("lang");
  const langManual = localStorage.getItem("lang_manual") === "1";

  if (langManual && (savedLang === "jp" || savedLang === "ch")) {
    return savedLang;
  }

  const lang = getBrowserLang();
  localStorage.setItem("lang", lang);
  localStorage.removeItem("lang_manual");
  return lang;
}

export function setManualLang(lang) {
  localStorage.setItem("lang", lang);
  localStorage.setItem("lang_manual", "1");
}
